import { Suspense } from "react";
import Providers from "./layouts/provider.layout";
import { Loader } from "./components";
import ErrorBoundary from "./ErrorBoundary";
import { ThemeProvider } from "./contexts/ThemeContext";
import * as Sentry from "@sentry/react";
import './assets/rsuite-theme.less';
import config from "./config";

function App() {
  if (!Sentry.isInitialized() && config.sentry.dsn) {
    Sentry.init({
      dsn: config.sentry.dsn,
      release: `logging-web@${config.version}`,
      dist: config.version,
      environment: config.env,
      _experiments: { enableLogs: true },
      integrations: [
        Sentry.replayIntegration({
          maxReplayDuration: 30000,
          maskAllText: false,
          blockAllMedia: false,
        })
      ],
      sendDefaultPii: true,
      replaysSessionSampleRate: 0,
      replaysOnErrorSampleRate: config.sampleRate,
    });
  }

  return (
    <ThemeProvider>
      <div id="app" className="app noselect">
        <Suspense fallback={<Loader />}>
          <ErrorBoundary>
            <Providers />
          </ErrorBoundary>
        </Suspense>
      </div>
    </ThemeProvider>
  );
}

export default App;
